import { getFromBrandConfig } from 'brand-config';

export function getBrandVaultProject() {
  return getFromBrandConfig('vaultProject');
}

/**
 * The brand host the app is being served as — the key the brands endpoint is looked up by, and
 * the thing that decides which brand the member sees.
 *
 * `localhost` has no brand record of its own, so a plain local run answers as `VITE_HOST`
 * instead; serving as the brand's own host (VITE_SERVE_AS_BRAND_HOST, see vite.config.ts) skips
 * that fallback because `host` is already the brand host.
 */
export function getBrandDomain() {
  const { host } = window.location;
  const hostname = host.startsWith('www') ? host.slice(4) : host;

  return hostname.startsWith('localhost')
    ? import.meta.env.VITE_HOST
    : hostname;
}
